export const isoDay = (date) =>
  `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
export const monthWindow = (date) => ({
  start: isoDay(new Date(date.getFullYear(), date.getMonth(), 1)),
  end: isoDay(new Date(date.getFullYear(), date.getMonth() + 1, 0)),
});
export const monthLabel = (start) =>
  new Intl.DateTimeFormat("en-US", { month: "long", year: "numeric" }).format(
    new Date(`${start}T12:00:00`),
  );
export function overviewMonths(today = new Date()) {
  const current = monthWindow(today),
    upcoming = monthWindow(
      new Date(today.getFullYear(), today.getMonth() + 1, 1),
    );
  return {
    current,
    upcoming,
    due: isoDay(new Date(today.getFullYear(), today.getMonth(), 15)),
  };
}
const overlaps = (start, end, month) =>
  Boolean(start && end && start <= month.end && end >= month.start);
export function monthAttention(
  { timeOff = [], coverage = [], swaps = [] },
  month,
) {
  const items = [];
  timeOff.forEach((r) => {
    const dates = r.approved_outcome || r.request || {};
    if (
      ["requested", "approved"].includes(r.status) &&
      overlaps(dates.start_date, dates.end_date || dates.start_date, month)
    )
      items.push({
        id: `time-off-${r.id}`,
        title: "Time-off request",
        name: r.requester_name || "Name unavailable",
        date: dates.start_date,
        end: dates.end_date,
        detail:
          r.status === "approved"
            ? "Approved · update schedule"
            : "Awaiting review",
        to: `/scheduling/time-off?request=${encodeURIComponent(r.id)}&boutique=${encodeURIComponent(r.boutique_code || "")}`,
        action: "Review",
        kind: "timeOff",
      });
  });
  coverage.forEach((r) => {
    const c = r.coverage || {};
    if (
      ["open", "volunteer_received"].includes(r.status) &&
      overlaps(c.date, c.date, month)
    )
      items.push({
        id: `coverage-${r.id}`,
        title: "Coverage needed",
        name: c.requester_employee_name || "Coverage opportunity",
        date: c.date,
        detail: [c.start, c.end].filter(Boolean).join("–"),
        to: `/scheduling/coverage/${r.id}`,
        action: "Find cover",
        kind: "coverage",
      });
  });
  swaps.forEach((r) => {
    const s = r.swap || {},
      dates = [
        s.my_shift,
        s.target_shift,
        ...(r.volunteers || []).map((o) => o.offered_shift),
      ].filter(Boolean);
    if (
      ["requested", "matched"].includes(r.status) &&
      dates.some((d) => overlaps(d.date, d.date, month))
    ) {
      const d = dates.find((d) => overlaps(d.date, d.date, month));
      items.push({
        id: `swap-${r.id}`,
        title: "Shift swap",
        name: s.requester_employee_name || r.created_by_name || "Swap request",
        date: d.date,
        detail: [d.start, d.end].filter(Boolean).join("–"),
        to: `/scheduling/swaps/${r.id}`,
        action: "Review",
        kind: "swaps",
      });
    }
  });
  return items.sort(
    (a, b) => a.date.localeCompare(b.date) || a.id.localeCompare(b.id),
  );
}
export function previewRoster(period, team = []) {
  const roster = Array.isArray(period?.eg_roster) ? period.eg_roster : team;
  const members = new Map(roster.map((r) => [String(r.employee_id), r]));
  (period?.current_version?.eg_shifts || []).forEach((s) => {
    if (!members.has(String(s.employee_id)))
      members.set(String(s.employee_id), {
        employee_id: s.employee_id,
        employee_name: s.employee_name || "Name unavailable",
      });
  });
  return [...members.values()];
}
export function previewWeeks(month) {
  const day = new Date(`${month.start}T12:00:00`);
  day.setDate(day.getDate() - ((day.getDay() + 6) % 7));
  const weeks = [];
  while (isoDay(day) <= month.end) {
    weeks.push(isoDay(day));
    day.setDate(day.getDate() + 7);
  }
  return weeks;
}
